import { Gutenberg } from './types_and_parser/types.ext.gen'
import { Block } from './types_and_parser/standard_blocks.gen'
import { BlockData } from '../cms/blocks/types.gen'
import { Option, none } from 'widgets-for-react'
import { ExtraImages } from '../public_site/utils/extra_images.mod'


export const TransformStandardBlock = (b: Gutenberg.Block): Block => {
  return { ...b, kind: b.blockName } as Block
}

export const WordPressBlock_To_WidgetBlock = <CustomBlockData, CustomBlocks extends { kind: CustomBlocks['kind'] }, CustomPageData>(
  block: Block,
  index: number,
  extra_data: CustomPageData,
  mk_block?: (block: CustomBlocks, block_index: number, extra_data: CustomPageData) => Option<CustomBlockData>
): Option<BlockData<CustomBlockData, ExtraImages> | CustomBlockData> => {
  if (mk_block) {
    let maybe_res = mk_block(block as any, index, extra_data)
    if (maybe_res.v.kind == 'r') return maybe_res
  }
  switch (block.kind) {
    default: {
      console.warn('Unsupported block.', block)
      return none<BlockData<CustomBlockData, ExtraImages> | CustomBlockData>()
    }
  }
}
